import styled from 'styled-components';

export const NamedOffendersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;
